import create from 'zustand';

const useVisibilityStore = create((set, get) => ({
    visibilityRules: null,
    loading: true,

    fetchVisibilityRules: async (apiProvider) => {
        const { visibilityRules, loading } = get();

        // Avoid re-fetching if already loaded
        if (visibilityRules || !loading) {
            return;
        }

        try {
            const visibilityRules = await apiProvider.Get("Employee/GetVisibilityRules");
            console.log("Visibility Rules Response:", visibilityRules);
            if (!visibilityRules.error) {
                set({ visibilityRules, loading: false });
            } else {
                console.error("Error fetching visibility rules:", visibilityRules.error);
                set({ visibilityRules: null, loading: false });
            }
        } catch (error) {
            console.error("Failed to fetch visibility rules:", error);
            set({ visibilityRules: null, loading: false });
        }
    },

    allPropsPresent: () => {
        const rules = get().visibilityRules;
        return rules && Object.keys(rules).length > 0;
    },
}));

export default useVisibilityStore;